var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6833 35.0167C16.6833 36.85 18.1667 38.3333 20 38.3333C21.8333 38.3333 23.3167 36.85 23.3167 35.0167H16.6833ZM20 10C24.6 10 28.3333 13.7333 28.3333 18.3333V30H11.6667V18.3333C11.6667 13.7333 15.4 10 20 10ZM20 2.5C18.6167 2.5 17.5 3.61667 17.5 5V6.95C12.2667 8.08333 8.33333 12.75 8.33333 18.3333V28.3333L5 31.6667V33.3333H35V31.6667L31.6667 28.3333V18.3333C31.6667 12.75 27.7333 8.08333 22.5 6.95V5C22.5 3.61667 21.3833 2.5 20 2.5ZM18.3333 13.3333H21.6667V20H18.3333V13.3333ZM18.3333 23.3333H21.6667V26.6667H18.3333V23.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationImportant);
export default __webpack_public_path__ + "static/media/notification_important.c3730940272ae95ef5339d8153b24ead.svg";
export { ForwardRef as ReactComponent };